import React from 'react';
import { string, func } from 'prop-types';
import { Input } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/fiverr_context';
import { UI_MODES } from '../../constants';
import NeedHelp from '../NeedHelp';
import EditButton from '../EditButton';
import CancelButton from '../CancelButton';

import './style.scss';

const MessageBody = ({ username, mode, email, errorMessage, onEmailChange, onEditClick, onCancelClick }) => (
    <div className="message-body">
        <div>
            <b>
                <I18n k="layout.global_messages.user_activation.need_to_activate" params={{ username }}/>
                &nbsp;<div className="email-container">
                    {mode === UI_MODES.EDIT ?
                        <Input className="input-container"
                            inputClassName="input"
                            value={email}
                            onChange={onEmailChange}/>
                        : ` (${email})`
                    }
                    {mode !== UI_MODES.SUBMITTED && mode !== UI_MODES.EDIT &&
                        <EditButton onClick={onEditClick}/>
                    }
                    {mode !== UI_MODES.SUBMITTED && mode === UI_MODES.EDIT &&
                        <CancelButton onClick={onCancelClick}/>
                    }
                </div>
            </b>
            {errorMessage &&
                <div className="error-container">
                    <I18n k={errorMessage}/>
                </div>
            }
        </div>
        <NeedHelp/>
    </div>
);

MessageBody.propTypes = {
    username: string.isRequired,
    mode: string.isRequired,
    email: string.isRequired,
    errorMessage: string,
    onEmailChange: func.isRequired,
    onEditClick: func.isRequired,
    onCancelClick: func.isRequired
};

export default MessageBody;
